interface DiagnosticEvent {
  at: string;
  kind: "error" | "rejection" | "performance";
  message: string;
  path: string;
  duration?: number;
}

const KEY = "tolupanes:client-diagnostics";

function record(event: DiagnosticEvent) {
  try {
    const current = JSON.parse(sessionStorage.getItem(KEY) ?? "[]") as DiagnosticEvent[];
    sessionStorage.setItem(KEY, JSON.stringify([...current, event].slice(-50)));
  } catch { /* Diagnostics must never interrupt the portal. */ }
}

export function installClientObservability() {
  window.addEventListener("error", (event) => record({ at:new Date().toISOString(), kind:"error", message:event.message || "Error de recurso", path:location.pathname }));
  window.addEventListener("unhandledrejection", (event) => record({ at:new Date().toISOString(), kind:"rejection", message:event.reason instanceof Error ? event.reason.message : String(event.reason), path:location.pathname }));
  window.addEventListener("load", () => {
    const navigation = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined;
    if (navigation) record({ at:new Date().toISOString(), kind:"performance", message:"Carga completa", path:location.pathname, duration:Math.round(navigation.loadEventEnd) });
  }, { once:true });
}

export function readClientDiagnostics(): DiagnosticEvent[] {
  try { return JSON.parse(sessionStorage.getItem(KEY) ?? "[]") as DiagnosticEvent[]; }
  catch { return []; }
}
